import { DutyType } from './models/DutyType';
import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';

export const DutyTypeStore = types
  .compose(
    getBaseStore<Instance<typeof DutyType>, SnapshotOut<typeof DutyType>>(DutyType, 'dutyTypeId', 'dutyType'),
    types.model('DutyTypeStore', {}),
  )
  .views((self) => ({
    getByIdOrNew(id: number) {
      if (id > 0) {
        return self.datas.get(id.toString());
      } else {
        return {
          dutyTypeId: undefined,
        };
      }
    },
  }));
